<template>
    <div class="modal is-active">
        <div class="modal-background" />

        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ header }}</p>

                <button @click="close" class="delete" :aria-label="$t('global.actions.close')" />
            </header>

            <section class="modal-card-body">
                <slot name="content" />
            </section>

            <footer class="modal-card-footer">
                <slot name="footer" />
            </footer>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../styles/_variables";
    .modal-card {
        .modal-card-head {
            border-radius: 0;
            text-align: center;
        }

        .modal-card-body {
            text-align: left;
        }

        .modal-card-footer {
            border-radius: 0;
            border: none;
            background: $white;
            padding: 10px;
        }
    }
</style>

<script>
    export default {
        props: {
            header: {
                type: String,
                required: true,
            },
        },

        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/global/components/ModalCard.vue